const Alluvial = () => {
  const StartDate = new datePicker({
    container: '#start-date',
    elementExists: true,
    onChange: () => {
      updateData();
    },
  }).setDate('1994-01-01');

  const EndDate = new datePicker({
    container: '#end-date',
    elementExists: true,
    onChange: () => {
      updateData();
    },
  }).setDate('2025-09-30');

  const parameter = new Dropdown({
    container: '#parameter',
    elementExists: true,
    onChange: () => {
      updateData();
    },
  }).val(46);

  const SurfaceWater = new Dropdown({
    container: '#surface-water-location',
    elementExists: true,
    onChange: () => {
      updateData();
    },
  }).val(68);

  const groundwater = new Dropdown({
    container: '#groundwater-location',
    elementExists: true,
    onChange: () => {
      updateData();
    },
  }).val(64);

  const alluvialConcentrationsReq = {
    url: '/sites/all/scripts/view/alluvial.php',
    table: 'viewer.results_simple',
    fields: ['*'],
    date_field: 'rdate',
    value_field: 'rvalue_converted',
    units_field: 'unit_name',
    start_date: StartDate.getDate(),
    end_date: EndDate.getDate(),
    parameter: 46,
    location1: 64,
    location2: 68,
    sort: 'rdate ASC, location_name ASC, parameter ASC',
    drupal_user_switch: false,
    drupal_userid: 1,
  };

  const alluvialConcentrationsOpt = {
    container: '#alluvial-graph-section',
    chartType: 'multi-dimensional scatter',
    categoryField: 'location_name',
    categoryField2: 'parameter',
    colors: ['#23b578', '#5C6BC0'],
    gridlines: true,
    xAxis: true,
    xAxisFormat: '‘%y',
    yAxis: true,
    tooltipDateFormat: 'MMM DD, YYYY',
    legend: true,
  };

  /**
   * Function used to update charts when user changes the date filters
   */
  function updateData() {
    alluvialConcentrationsReq.start_date = StartDate.getDate();
    alluvialConcentrationsReq.end_date = EndDate.getDate();
    alluvialConcentrationsReq.parameter = parameter.val();
    alluvialConcentrationsReq.location1 = SurfaceWater.val();
    alluvialConcentrationsReq.location2 = groundwater.val();

    const alluvialConcentrationsChart = new Chart(alluvialConcentrationsReq, alluvialConcentrationsOpt);
  }

  const alluvialConcentrationsChart = new Chart(alluvialConcentrationsReq, alluvialConcentrationsOpt);
};
